import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getAllAmlPlayerListingStart,
    getAllAmlPlayerListingSuccess,
    getAllAmlPlayerListingFailure,
    getAmlThresholdDataStart,
    getAmlThresholdDataSuccess,
    getAmlThresholdDataFailure,
    setAmlThresholdDataStart,
    setAmlThresholdDataSuccess,
    setAmlThresholdDataFailure
  },
  reducer
} = createSlice({
  name: 'amlModule',
  initialState: {
    error: null,
    loading: false,
    amlPlayersDetails: null,
    thresholdData: null
  },
  reducers: {
    getAllAmlPlayerListingStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    getAllAmlPlayerListingSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      amlPlayersDetails: payload?.flaggedPlayers,
      amlThresholdValue: payload?.threshold
    }),
    getAllAmlPlayerListingFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload
    }),
    getAmlThresholdDataStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    getAmlThresholdDataSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      thresholdData: payload
    }),
    getAmlThresholdDataFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload
    }),
    setAmlThresholdDataStart: (state) => ({
      ...state,
      loading: true,
      error: null
    }),
    setAmlThresholdDataSuccess: (state, { payload }) => ({
      ...state,
      thresholdData: payload,
      loading: false
    }),
    setAmlThresholdDataFailure: (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload
    })
  }
})

export default reducer

export {
  getAllAmlPlayerListingStart,
  getAllAmlPlayerListingSuccess,
  getAllAmlPlayerListingFailure,
  getAmlThresholdDataStart,
  getAmlThresholdDataSuccess,
  getAmlThresholdDataFailure,
  setAmlThresholdDataStart,
  setAmlThresholdDataSuccess,
  setAmlThresholdDataFailure
}
